var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconJournals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 70,
    height: 70,
    rx: 10,
    fill: "#FFA826"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5714 30H51.4286V21.4286C51.4286 20.6396 50.789 20 50 20H21.4286C20.6396 20 20 20.6396 20 21.4286V54.2857C20 57.4416 22.5584 60 25.7143 60H54.2857C57.4416 60 60 57.4416 60 54.2857V31.4285C60 30.6396 59.3604 30 58.5714 30ZM31.4285 27.1428H40C40.789 27.1428 41.4286 27.7824 41.4286 28.5714C41.4286 29.3604 40.789 30 40 30H31.4285C30.6395 30 29.9999 29.3604 29.9999 28.5714C29.9999 27.7824 30.6396 27.1428 31.4285 27.1428ZM44.2857 54.2857H27.1428C26.3538 54.2857 25.7142 53.6461 25.7142 52.8571C25.7142 52.0681 26.3538 51.4285 27.1428 51.4285H44.2857C45.0747 51.4285 45.7143 52.0681 45.7143 52.8571C45.7143 53.6461 45.0747 54.2857 44.2857 54.2857ZM44.2857 48.5714H27.1428C26.3538 48.5714 25.7142 47.9318 25.7142 47.1428C25.7142 46.3538 26.3538 45.7142 27.1428 45.7142H44.2857C45.0747 45.7142 45.7143 46.3538 45.7143 47.1428C45.7143 47.9318 45.0747 48.5714 44.2857 48.5714ZM44.2857 42.8572H27.1428C26.3538 42.8572 25.7142 42.2176 25.7142 41.4286C25.7142 40.6396 26.3538 40 27.1428 40H44.2857C45.0747 40 45.7143 40.6396 45.7143 41.4286C45.7143 42.2176 45.0747 42.8572 44.2857 42.8572ZM44.2857 37.1428H27.1428C26.3538 37.1428 25.7142 36.5033 25.7142 35.7142C25.7142 34.9252 26.3538 34.2856 27.1428 34.2856H44.2857C45.0747 34.2856 45.7143 34.9252 45.7143 35.7142C45.7143 36.5033 45.0747 37.1428 44.2857 37.1428ZM57.1428 54.2857C57.1428 55.8636 55.8636 57.1428 54.2857 57.1428C52.7078 57.1428 51.4286 55.8636 51.4286 54.2857V32.8571H57.1429V54.2857H57.1428Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJournals);
export default __webpack_public_path__ + "static/media/icon_journals.9fccdb9b49f30465153c2e5a961cea1c.svg";
export { ForwardRef as ReactComponent };